import { DashboardApiKeys } from '@/pages/DashboardApiKeys'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/apikeys')({
  component: DashboardApiKeys,
  meta: () => [{ title: 'API Keys' }],
})
